import { Seo } from 'src/components/seo';
import { brandConfig } from 'src/config/brand';
import { usePageView } from 'src/hooks/use-page-view';
import { HomeHero } from 'src/sections/home/home-hero';
import { HomeFeatures } from 'src/sections/home/home-features';
import { HomeProcess } from 'src/sections/home/home-process';
import { HomeCta } from 'src/sections/home/home-cta';
import { HomeFaqs } from 'src/sections/home/home-faqs';

const Page = () => {
  usePageView();

  return (
    <>
      <Seo title={brandConfig.title} />
      <main>
        <HomeHero />
        <HomeProcess />
        <HomeFeatures />
        <HomeFaqs />
        <HomeCta />
      </main>
    </>
  );
};

export default Page;
